var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportIndex',{attrs:{"endpoint":_vm.getEndpoint,"fstId":("vehicleReports_" + _vm.getId),"qso":_vm.getEndpointOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }